import React, {useEffect, useState} from "react";
import firebase from "firebase";
import {UpdateUserCount} from "./helpers/UpdateUserCount";
import App from "./App";

function AppWrapper(){

    //Student Acount variables
    const [userName, setUserName] = useState('');
    const [loginStatus, setLoginStatus] = useState(false);

    const [loading, setLoading] = useState(false);

    //Switches entire website according to class level
    // 1 => class 101
    // 2 => class 102
    const [classLevel, setClassLevel] = useState(1);

    useEffect(() => {
        setLoading(true);

        //Checking if user is logged in
        firebase.auth().getRedirectResult().then( function (result) {
            if (result.credential) {
                setLoginStatus(true);
                // This gives you a Google Access Token. You can use it to access the Google API.
                var token = result.credential.accessToken;
                // The signed-in user info.
                var user = result.user;
                setUserName(user.email.split('@')[0]);

            }

        }).then(()=>setLoading(false)).catch(function (error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            // The email of the user's account used.
            var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            var credential = error.credential;
            // ...
        });

        //If user is already logged in, display username and declare login status as logged in
        firebase.auth().onAuthStateChanged((user) => {
            if(user){
                setLoginStatus(true);
                setUserName(user.email.split('@')[0]);
                UpdateUserCount();
            }
        })

    },[]);


    //Firebase's login in new window
    const loginUser = () => {
        let provider = new firebase.auth.GoogleAuthProvider();
        firebase.auth().signInWithRedirect(provider);

    };

    //Clicking on navbar's username will logout user
    const logoutUser = () => {
        firebase.auth().signOut().then(() => setLoginStatus(false));
    };

    //Change class level to dropdown value
    //1 => class 101
    //2 => class 102
    const handleClassLevel = (event,{value}) => {
        setClassLevel(value);
    };

    return (
        <>
            <App
                userName={userName}
                loginStatus={loginStatus}
                loading={loading}
                classLevel={classLevel}
                loginUser={loginUser}
                logoutUser={logoutUser}
                handleClassLevel={handleClassLevel}
            />
        </>
    )
}

export default AppWrapper
